(function() {
  'use strict';

  $(function() {
    addClassActiveToMenu();
  });

  function addClassActiveToMenu() {
    $('ul.sidebar-elements  a').filter(function (index, element) {
      const linkMenu = this.href.split('/');
      const localization = location.pathname.split('/');
      const secondParam = localization[2];
      const thirdParam = localization[3];

      const lastMenu = linkMenu[linkMenu.length - 1];

      if (secondParam === lastMenu
        || lastMenu === thirdParam) {
        return true;
      }
    }).addClass('active-a');
  }

  let menuIcon = $('.responsive-toggle');
  let icon = $('.icon-toggle');

  menuIcon.on('click', function() {
    if ($(this).hasClass('collapsed')) {
      icon.removeClass('fa-bars');
      icon.addClass('fa-times');
    } else {
      icon.removeClass('fa-times');
      icon.addClass('fa-bars');
    }
  });

})();



// WEBPACK FOOTER //
// ./resources/assets/js/store/menu.js